import { useEffect, useState } from 'react'
import { pickApiCredentialFields } from '@/models/lock-setting'
import type { AccountInfo, ApiCredential, ApiCredentialField, LockType } from '@/models/lock-setting'

export const useSmartLockApiCredential = (lockType: LockType, accountInfos: AccountInfo[] | undefined) => {
  const [value, setValue] = useState<ApiCredential>({})
  const [errorFields, setErrorFields] = useState<ApiCredentialField[]>([])

  const fields = pickApiCredentialFields(lockType)
  // 保存済みの認証情報は取得できないため、未連携のときだけ入力を必須とする
  const isRequired = !!fields.length && !accountInfos?.find(account => account.lockType === lockType)?.isConnected

  const onChange = (field: ApiCredentialField, input: string) => {
    setValue(current => ({ ...current, [field]: input }))
    setErrorFields(current => current.filter(errorField => errorField !== field))
  }

  const clear = () => {
    setValue({})
    setErrorFields([])
  }

  // 種別ごとに入力項目が異なるため、切り替え時に前の種別の入力値を持ち越さない
  useEffect(() => {
    clear()
  }, [lockType])

  const validate = () => {
    const emptyFields = isRequired ? fields.filter(field => !value[field]) : []
    setErrorFields(emptyFields)
    return !emptyFields.length
  }

  // 未入力での保存は「変更しない」扱いにするため、入力があった項目だけ送信する
  const requestParams = (): ApiCredential =>
    fields.reduce<ApiCredential>((params, field) => (value[field] ? { ...params, [field]: value[field] } : params), {})

  return { fields, value, errorFields, onChange, clear, validate, requestParams }
}
